import { PplButtonModule } from '../button';
import { PplDialogModule } from '../dialog';
import { PplFormModule } from '../form';
import { PplIconModule } from '../icon';
import { PplInfoBoxModule } from '../info-box';
import { PplInputModule } from '../input';
import { PplMenuModule } from '../menu';
import { PplPopoverModule } from '../popover';
import { PplPopoverDropdownModule } from '../popover-dropdown';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PplImageEditorComponent } from './image-editor.component';

@NgModule({
  imports: [
    CommonModule,
    PplIconModule,
    PplButtonModule,
    PplPopoverModule,
    PplPopoverDropdownModule,
    PplDialogModule,
    PplMenuModule,
    PplInfoBoxModule,
    PplFormModule,
    PplInputModule
  ],
  declarations: [
    PplImageEditorComponent
  ],
  exports: [
    PplImageEditorComponent
  ]
})
export class PplImageEditorModule {}

export * from './image-editor.component';
